import { render } from "./DisciplinaryHrActions.vue?vue&type=template&id=2966785e&scoped=true"
import script from "./DisciplinaryHrActions.vue?vue&type=script&lang=js"
export * from "./DisciplinaryHrActions.vue?vue&type=script&lang=js"

import "./DisciplinaryHrActions.vue?vue&type=style&index=0&id=2966785e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2966785e"]])

export default __exports__